var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title",class:_vm.getTitleClass(_vm.size, _vm.lineSeparator)},[_vm._t("default")],2),(_vm.hasSubtitle)?_c('h3',{staticClass:"sub-title"},[_vm._t("subtitle")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }